module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/tee/2-3f19ded07b1b123c1799ccc4a11cabf5.jpg";